// extracted by mini-css-extract-plugin
module.exports = {"zoomIcon":"ProductZoomInModal_zoomIcon__ZghvK","closeIcon":"ProductZoomInModal_closeIcon__hXw2Z"};